const PostmanButton = () => {
  return (
    <div>
      <a
        href="https://www.postman.com/gfs0020/workspace/high-score-website/collection/29724145-f91d7470-4766-462b-ab6c-24b9cc760758?action=share&creator=29724145"
        target="_blank"
        rel="noreferrer">
        Postman Collection
      </a>
    </div>
  );
};

export default PostmanButton;
